__turbopack_context__.v({
  "crossButton": "ModalMinimalHeader-module__7cl_ca__crossButton",
  "dark": "ModalMinimalHeader-module__7cl_ca__dark",
  "header": "ModalMinimalHeader-module__7cl_ca__header",
  "rightButton": "ModalMinimalHeader-module__7cl_ca__rightButton",
});
